<template>
  <div>
    <AddRecommendation
      :showAddRecommendation="showAddRecommendation"
      @close="showAddRecommendation = false"
      :reload="reload"
    ></AddRecommendation>
    <div class="bg-white rounded-md">
      <div
        class="border-b-0.5 flex flex-wrap lg:gap-0 gap-4 justify-end items-center py-3"
      >
        <div>
          <button
            @click="showAddRecommendation = true"
            class="bg-primary text-white rounded-full px-3 py-1 text-sm"
            v-if="['hr manager', 'manager'].includes(getUserType.toLowerCase())"
          >
            Add Recommendation
          </button>
        </div>
      </div>
      <div class="">
        <ve-table :columns="columns" :table-data="recommendations"  />
        <transition name="fade">
          <div
              v-if="loading"
              class="inset-0 absolute z-50 bg-black bg-opacity-10 w-full"
          >
            <loader class="center-h-v" />
          </div>
        </transition>
        <div
            v-if="!loading && !recommendations"
            class="flex flex-col justify-center items-center h-full mt-5"
        >
          <el-empty :image-size="70" description="No Data"></el-empty>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import AddRecommendation from "./addRecommendation.vue";
import Loader from "@/components/loader/loader.vue";
import {mapGetters} from "vuex";
import axios from "axios";
export default {
  name: "RecommendationHome",
  components: { AddRecommendation, Loader },
  computed:{
    ...mapGetters(["getOrganization", "getToken", "getUserType", "getCurrentEmployeeId"]),
  },
  data() {
    return {
      showAddRecommendation: false,
      currentPeriod: null,
      loading:false,
      columns: [
        {
          field: "Recommendation Type",
          key: "a",
          title: "Recommendation Type",
          renderBodyCell: ({row}) => (
              <p className="capitalize">{row.RecommendationType}</p>
          ),
        },

        { field: "RecommendationDate", key: "c", title: "Recommendation Date",
          renderBodyCell: ({row}) => (
              <p className="capitalize">{row.PerformancePeriod}</p>
          ),
        },

        {
          field: "Comments",
          key: "f",
          title: "Comments",
          renderBodyCell: ({row}) => (
              <p className="capitalize">{row.Description}</p>
          ),
        },
      ],
      recommendations:[],
      tableData: [
        {
          Recommendation: "Training needed",
          RecommendationDate: "15 Dec 2022",
          CycleName: "Half Year",
          Grade: 3.1,
          Comments: "56%",
        },
      ],
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
    };
  },
  created() {
    this.getPerformancePeriodSetups()
  },
  methods: {
    reload() {
      this.showAddRecommendation = false
    },
    getPerformancePeriodSetups() {
      this.loading = true;
      let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {

            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.reviewPeriods = response.data.Data;
              this.setCurrentPeriod();
              this.loading = false;
            } else {
              this.$notify.error({
                title: 'Failure',
                message: response.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;
            this.$notify.error({ title: 'Failure', message: error.message });
          }
      );
    },
    setCurrentPeriod() {
      const today = new Date(); // Get the current date
      // console.log(this.reviewPeriods);
      // Find the current period where today is between startDate and endDate
      this.currentPeriod = this.reviewPeriods.find((period) => {
        const startDate = new Date(period.StartDate);
        const endDate = new Date(period.EndDate);

        return today >= startDate && today <= endDate;
      });

      if (!this.currentPeriod) {
        console.log('No current period found.');
      }
      this.getRecommendations()
    },
    getRecommendations(){
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(`${this.getOrganization}/performance/recommendation/${this.$ApiVersion}/request`
          ,{
            params:{
              employeeId:'',
              performancePeriodId: this.currentPeriod.Id,
            }, ...options
          } ).then((response)=>{
            this.loading=false
            if (response.data.StatusCode===200){
              this.recommendations=response.data.Data
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error)=>{
            this.get_error = error.message;
          }
      )
    }
  },
};
</script>
